export enum TableSelectOrderBy {
	Id = 'id',
	Date = 'date',
}